module.exports = __webpack_public_path__ + "media/images/indicators/sewage-7ceccd3de821e638ca0c893a754435f3.png";